import { defineRule } from 'vee-validate'
import { required, email, min, max, min_value, max_value, one_of, is, numeric } from '@vee-validate/rules'

defineRule('email', email)
defineRule('required', required)
defineRule('numeric', numeric)
defineRule('min', min)
defineRule('max', max)
defineRule('is', is)
defineRule('min_value', min_value)
defineRule('max_value', max_value)
defineRule('oneOf', one_of)
